import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Home from '../pages/Home';
import OurStrains from '../pages/OurStrains';
import ProductPage from '../pages/ProductPage';
import FaqPage from '../pages/FaqPage';
import WherePage from '../pages/WherePage';
import ContactPage from '../pages/ContactPage';
import MediaPage from '../pages/MediaPage'
import NewsPage from '../pages/NewsPage'
import PrivacyPage from '../pages/PrivacyPage';
import ErrorPage from '../pages/ErrorPage';
import AgeGate from '../pages/AgeGate';
import BecomeInsider from '../pages/BecomeInsider';
import Preview from '../pages/Preview';
import PrivateRoute from './privateRoute';

class Routes extends Component {
  render() {
    return (
      <Switch location={this.props.location}>
        <Route exact path="/age-gate" component={AgeGate}></Route>
        <PrivateRoute exact path="/" component={Home}></PrivateRoute>
        <Route path="/insider" component={BecomeInsider}></Route>
        <Route path="/initie" component={BecomeInsider}></Route>
        <PrivateRoute exact path="/our-strains" component={OurStrains}></PrivateRoute>
        <PrivateRoute exact path="/nos-souches" component={OurStrains}></PrivateRoute>
        <PrivateRoute path="/our-strains/:uid" component={(props) => (<ProductPage {...props}/>)}></PrivateRoute>
        <PrivateRoute path="/nos-souches/:uid" component={(props) => (<ProductPage {...props}/>)}></PrivateRoute>
        <Route path="/contact" component={ContactPage}></Route>
        <Route path="/contactez-nous" component={ContactPage}></Route>
        <PrivateRoute path="/frequently-asked-questions" component={FaqPage}></PrivateRoute>
        <PrivateRoute path="/questions-frequemment-posees" component={FaqPage}></PrivateRoute>
        <PrivateRoute path="/where-to-buy" component={WherePage}></PrivateRoute>
        <PrivateRoute path="/ou-acheter" component={WherePage}></PrivateRoute>
        <PrivateRoute path="/media" component={MediaPage}></PrivateRoute>
        <PrivateRoute path="/medias" component={MediaPage}></PrivateRoute>
        <PrivateRoute path="/news-and-events" component={NewsPage}></PrivateRoute>
        <PrivateRoute path="/infos-et-evenements" component={NewsPage}></PrivateRoute>
        <Route path="/privacy-policy" component={PrivacyPage}></Route>
        <Route path="/declaration-de-confidentialite" component={PrivacyPage}></Route>
        
        {/* Add the new preview route here */}
        <Route exact path="/preview" render={routeProps => <Preview {...routeProps} />} />

        <Redirect from="/lounge" to="/news-and-events"/>
        <Redirect from="*" to="/age-gate"/>
        <Route path="*" component={ErrorPage}></Route> 
      </Switch>
    )
  }
}


export default Routes


// WEBPACK FOOTER //
// ./src/router/routes.js